@let podValue = pod();
<div class="popular-bets-bet-builder-pod__top-container">
    <ms-popular-bets-bet-builder-pod-header
        [event]="event()"
        [showBadge]="showBadge()"
        [showLogo]="podValue.enableLogoHeader"
        [titleColor]="podValue.titleColor" />
    @if (podValue.summary) {
        <ms-popular-bets-pod-summary class="popular-bets-pod-summary" [summary]="podValue.summary" />
    }
    <div class="popular-bets-bet-builder-pod-events" [style.height.px]="minHeight()">
        @if (podValue.preCreatedOptions) {
            <ms-popular-bets-bet-builder-options
                [event]="event()"
                [options]="podValue.preCreatedOptions"
                [visibleOptionsLimit]="podValue.visibleOptionsLimit"
                [totalEventCount]="podValue.eventsCount"
                [isEpcotEnabled]="isEpcotEnabled()"
                [showMoreLessButtonVisible]="podValue.showMoreLessButtonVisible" />
        }
    </div>
</div>
<div [class.popular-bets-bet-builder-pod__bottom-container]="podValue.showMoreLessButtonVisible && !isEpcotEnabled()">
    @if (podValue.showMoreLessButtonVisible) {
        <ms-popular-bets-pod-show-more
            class="popular-bets-pod-show-more"
            [totalCount]="podValue.eventsCount"
            [defaultCount]="podValue.defaultNoOfLegs"
            [isEpcotEnabled]="isEpcotEnabled()"
            (expandChange)="onShowMoreLessButtonToggle($event)" />
    }

    @if (podValue.preCreatedOffer && podValue.preCreatedOptions) {
        <ms-popular-bets-pod-add-to-betslip
            class="popular-bets-add-to-betslip"
            [class.show-more-less-visible]="podValue.showMoreLessButtonVisible"
            [betBuilderMarket]="podValue.preCreatedMarket"
            [betBuilderOptions]="podValue.preCreatedOptions"
            [preCreatedOffer]="podValue.preCreatedOffer"
            [podType]="podValue.podType"
            [enableSinglePickSelection]="false"
            [podEvents]="podValue.events"
            [isEpcotEnabled]="isEpcotEnabled()"
            [tracking]="getTrackingDetails(podValue.preCreatedOptions.length)" />
    }
</div>
